import { useRef, useEffect, useState } from 'react'
import { DealersMap } from '@/components/dealers/DealersMap'
import { DealerCard } from '@/components/dealers/Dealers'
import { dealers } from '@/components/dealers/locations'
import { Dealer } from '@/types'

export default function Dealers() {
  const [selectedDealer, setSelectedDealer] = useState<Dealer | null>(null)
  const [hoveredDealer, setHoveredDealer] = useState<Dealer | null>(null)
  const scrollRef = useRef<HTMLDivElement>(null)

  // Scroll al card seleccionado
  useEffect(() => {
    if (!selectedDealer || !scrollRef.current) return
    const card = scrollRef.current.querySelector(`[data-dealer-id="${selectedDealer.id}"]`)
    if (card) {
      card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
    }
  }, [selectedDealer])

  return (
    <div className="fixed inset-0 bg-[#0f1629]">
      {/* Mapa fullscreen */}
      <DealersMap
        selectedDealer={selectedDealer}
        setSelectedDealer={setSelectedDealer}
        hoveredDealer={hoveredDealer}
      />

      {/* Barra inferior con scroll horizontal */}
      <div className="absolute inset-x-0 bottom-0 z-10">
        {/* Gradient fade sobre el mapa */}
        <div className="pointer-events-none h-16 bg-gradient-to-t from-black/40 to-transparent" />

        <div className="bg-white/95 backdrop-blur-xl border-t border-white/60 shadow-[0_-8px_40px_rgba(0,0,0,0.2)]">
          {/* Handle + título */}
          <div className="flex items-center justify-between px-5 pt-3 pb-2">
            <div>
              <h2 className="text-sm font-bold text-[#1F2240]">Sucursales</h2>
              <p className="text-xs text-gray-400">{dealers.length} ubicaciones</p>
            </div>
            <div className="mx-auto absolute left-1/2 -translate-x-1/2 top-1.5">
              <div className="h-1 w-8 rounded-full bg-gray-300" />
            </div>
          </div>

          {/* Scroll horizontal de cards */}
          <div
            ref={scrollRef}
            className="flex gap-3 overflow-x-auto px-4 pb-5 pt-1 snap-x snap-mandatory scrollbar-hide"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {dealers.map((dealer) => (
              <DealerCard
                key={dealer.id}
                dealer={dealer}
                isSelected={selectedDealer?.id === dealer.id}
                isHovered={hoveredDealer?.id === dealer.id}
                onClick={() => setSelectedDealer(dealer)}
                onHover={(d) => setHoveredDealer(d)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
